<div class="border-t-2 border-[var(--bg-color)] px-5 py-2.5 text-[var(--text-color)]">
  <ng-content/>
</div>
